import scatter from 'daisy-chart/src/layouts/scatter';

var randSize = 512;
var dataset = [];
var d, i;
for (i = 0; i < randSize ; i++) {
  let categoryUnit = String.fromCharCode(i  % 3 + 65);
  d = {category : categoryUnit, x : i , y: Math.random() * 10000, z: Math.random() * 10000}
  dataset.push(d);
}

scatter().data(dataset)
  .name('scatter')
  .container('#daisy-example')
  .dimension('category')
  .measures(['y', 'z'])
  .grid(true)
  .zoom(true)
  .axis('x').axis('y')
  .render();
    


// WEBPACK FOOTER //
// ./js/examples/zoomScatter.js